import RouteTemplate from 'ember-route-template';

import { concat } from '@ember/helper';
import { action } from '@ember/object';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import HeadTags from 'ember-cli-meta-tags/components/head-tags';
import NotificationContainer from 'ember-cli-notifications/components/notification-container';
import LinksTo from 'ember-route-state/components/links-to.gjs';
import { storageFor } from 'ember-local-storage';
import { pageTitle } from 'ember-page-title';
import { PortalTargets } from 'ember-primitives';
import 'rise-navigation';

import AccessibleOutlineStyle from 'rise-ui/components/accessible-outline-style.gjs';
import CFieldHeightOverlayContainer from 'rise-ui/components/c-field-height-overlay-container.gjs';
import DebugDebugMenu from 'rise-ui/components/debug/debug-menu.gjs';
import InHead from 'rise-ui/components/in-head.gjs';
import accessibleLayouts from 'rise-ui/helpers/accessible-layouts.js';
import and from 'rise-ui/helpers/and.js';
import classMod from 'rise-ui/helpers/class-mod.js';
import concatClasses from 'rise-ui/helpers/concat-classes.js';
import deployId from 'rise-ui/helpers/deploy-id.js';
import env from 'rise-ui/helpers/env.js';
import filter from 'rise-ui/helpers/filter.js';
import getBy from 'rise-ui/helpers/get-by.js';
import not from 'rise-ui/helpers/not.js';
import createMenuToggle from 'rise-ui/modifiers/create-menu-toggle.js';
import routeRefresh from 'rise-ui/utils/route-refresh.js';

export default RouteTemplate(class ApplicationComponent extends Component {
  @service breadcrumb;
  @service ssr;
  @service router;
  @service scrollRoot;
  @service userAgent;
  @storageFor('debug') debugStorage;
  @service headData;

  breadcrumbs = riseNavigation.breadcrumbs;
  menuItems = riseNavigation.menuItems;

  get isIOS() {
    return this.userAgent.os.isIOS;
  }

  @action didInsertScrollRoot(element) {
    return this.scrollRoot.setElement(element);
  }

  @action onRefresh() {
    routeRefresh(this);
  }

  @action onDebugExit() {
    this.debugStorage.set('show', false); // Store as hidden in local storage
    this.router.transitionTo({ queryParams: { debug: undefined } }); // Hide query param
  }

  <template>
    {{pageTitle (env "APP.TITLE_PREFIX") separator="" front=true}}
    {{pageTitle (concat "Bureau of Reclamation" (env "APP.TITLE_SUFFIX")) separator=" | "}}
    {{pageTitle "RISE"}}

    <InHead>
      {{deployId}}
      <HeadTags @headTags={{this.headData.headTags}} />
    </InHead>
    <AccessibleOutlineStyle/>
    <NotificationContainer/>
    <CFieldHeightOverlayContainer/>
    <PortalTargets />
    {{accessibleLayouts}}
    {{#if (and (not this.ssr.isSsr) @controller.debug)}}
      <DebugDebugMenu @onRefresh={{this.onRefresh}} @onExit={{this.onDebugExit}} />
    {{/if}}
    <div class="Main-content container clearfix"
      {{didInsert this.didInsertScrollRoot}}>
      <div class="l-wrapper-content">
        <div class="Breadcrumbs">
          <ul class="resetList">
            {{#each (filter this.breadcrumbs filter=(getBy "main")) as | crumb |}}
              <li>
                <LinksTo @route={{crumb.route}}
                  @url={{unless crumb.route crumb._url}}
                >{{crumb.label}}</LinksTo>
              </li>
            {{/each}}
            {{#each this.breadcrumb.crumbs as | crumb |}}
              <li>
                <LinksTo @route={{crumb.params}}>{{crumb.text}}</LinksTo>
              </li>
            {{/each}}
          </ul>
        </div>
      {{#if false}}
        <div class="l-welcome">
          <LinksTo @route="login">Login</LinksTo> or
          <LinksTo @route="login">Create Account</LinksTo>
          <i>OR</i> Welcome <strong title="aodell@usbr.gov">Allison</strong>
          <i>or</i> <strong>aodell@usbr.gov</strong><br>
          <LinksTo @route="account">My Account</LinksTo> |
          <LinksTo @route="logout">Log Out</LinksTo><br>
        </div>
      {{/if}}
        <div class="Main-nav">
          <div class="LeftNav" role="navigation" {{createMenuToggle}}>
            <span class="LeftNav-title">Rise</span>
            <ul class="LeftNav-list">
              {{#each this.menuItems as | menuItem |}}
                <li class={{concatClasses
                  (classMod "l-secondary-nav__item" menuItem.isActive "--active")
                }}>
                  <LinksTo @route={{menuItem.route}}
                    @urlOpen={{unless menuItem.route menuItem._url}}
                  >{{menuItem.label}}</LinksTo>
                </li>
              {{/each}}
            </ul>
          </div>
        </div>
        <div class="Main-well">
          {{outlet}}
        </div>
      </div>
    </div>
  </template>
});
